import { Layout} from 'antd';
import React from 'react';
const {Footer } = Layout;
const TLFooter = (props)  => {
  const now = new Date()
  return (
    <Footer
      style={{
        textAlign: 'center',
      }}
    >
      {`Tomorrow's Legends LLC ${now.getFullYear()}`}
    </Footer>
)};
export default TLFooter;